import { AutoComplete, Col, DatePicker, Divider, Form, Input, Row, Select, Typography, message, notification } from 'antd';
import React, {useEffect, useState} from 'react';
import './RelativeInfo.scss'
import { gioiTinhOptions, quanHeThanNhanOptions } from 'assets/constants/select-catagory-options';
import {sharedDirectory, medicalExaminationService} from 'api';
import { toOptions } from '../../config';
import { useAppSelector } from 'redux/hooks';
import { RECEIVE_ACTION_TYPE } from 'types/enums/receive-action-type';
import { normalizePhoneNumber, removeSpaces, validatePhoneNumberLength } from 'helper/common';
import Notification from 'components/common/notification/notification';

const RelativeInfo = props => {
  const action = useAppSelector(state => state.receive);
  const {form, expandRelativeInfo, setExpandRelativeInfo} = props;
  const [provinces, setProvinces] = useState<any[] | null>(null);
  const [districts, setDistricts] = useState<any[] | null>(null);
  const [selectedDistrict, setSelectedDistrict] = useState<number>(null);
  const [communes, setCommunes] = useState<any[] | null>(null);
  const [selectedProvince, setSelectedProvince] = useState<number>(null);
  const [relation, setRelation] = useState<any>(null);

  const [isOpenBirthday, setIsOpenBirthday] = useState<any>(false);
  useEffect(() => {

  }, [isOpenBirthday])
  const onPhoneBlur = (e) => {
    const normalizedPhoneNumber = normalizePhoneNumber(e.target.value);
    if(normalizedPhoneNumber)
      form.setFieldValue('dienThoaiThanNhan', normalizedPhoneNumber)
  }
  const onPhoneFocus = (e) => {
    form.setFieldValue('dienThoaiThanNhan', removeSpaces(e.target.value))
  }
  const handleFreeList = (v, opts, namePath) => {
    if(opts.length > 1) {
      form.setFieldValue(namePath, v[v.length - 1])
    }
  }
  const hideReceiveInfo = () => {
    setExpandRelativeInfo(!expandRelativeInfo);
  };

  const fetchProvinces = async () => {
    try {
      let response = await sharedDirectory.getListProvince();
      setProvinces(response.data);
    } catch (err) {
      Notification("error", "Lỗi khi lấy danh mục tỉnh");
    }
  };
  const fetchDistricts = async provinceId => {
    try {
      let response = await sharedDirectory.getListDistrict({
        provinceId: provinceId,
      });
      setDistricts(response.data);
    } catch (err) {
      Notification("error", "Lỗi khi lấy danh mục huyện");
    }
  };

  const fetchCommunes = async districtId => {
    try {
      let response = await sharedDirectory.getListCommune({
        districtId: districtId,
      });
      setCommunes(response.data);
    } catch (err) {
      Notification("error", "Lỗi khi lấy danh mục xã");
    }
  };
  const toRelation = rls => {
    return rls.map(rl => {
      return {
        value: rl.tenQuanHe,
        label: rl.tenQuanHe,
      };
    });
  };
  const fetchRelation = async () => {
    try {
      let response = await medicalExaminationService.getListRelation();
      setRelation(response.data);
    } catch (err) {
      Notification("error", "Lỗi khi lấy danh mục quan hệ");
    }
  };

  const onProvinceChange = e => {
    setSelectedProvince(e);
    fetchDistricts(e);
  };
  const onDistrictChange = e => {
    setSelectedDistrict(e);
    fetchCommunes(e);
  };
  useEffect(() => {
    if (
      action.actionType === RECEIVE_ACTION_TYPE.EDITPHIEUKHAM ||
      action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI 
    ) {
      if (action.dataPassing && action.dataPassing.tinhThanNhan != null) {
        fetchDistricts(action.dataPassing.tinhThanNhan);
        setSelectedProvince(action.dataPassing.tinhThanNhan);
      }
      if (action.dataPassing && action.dataPassing.huyenThanNhan != null) {
        fetchCommunes(action.dataPassing.huyenThanNhan);
        setSelectedDistrict(action.dataPassing.huyenThanNhan);
      }
    }
  }, [action]);
  useEffect(() => {
    fetchProvinces();
    fetchRelation();
  }, []);
  useEffect(() => {
    form.setFieldValue("tinhThanNhan", selectedProvince);
  }, [selectedProvince]);
  useEffect(() => {
    form.setFieldValue("huyenThanNhan", selectedDistrict);
  }, [selectedDistrict]);
  useEffect(() => {}, [provinces, districts, communes]);
  return (
    <Row
      className="relative-info"
      style={expandRelativeInfo ? {} : {display: "none"}}
    >
      <Row onClick={hideReceiveInfo}>
        <Typography.Text strong>Nhân thân</Typography.Text>
        <Typography.Text className="describe-text">
          (Nhấn để rút gọn)
        </Typography.Text>
      </Row>
      <Divider type="horizontal" />
      <Row>
        <Form labelAlign="left" form={form}>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Họ tên</Typography.Text>}
                name="hoTenThanNhan"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input
                  className="data-input-field"
                  placeholder="Chọn"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Ngày sinh</Typography.Text>}
                name="ngaySinhThanNhan"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <DatePicker
                  className="data-picker-field"
                  placeholder="DD/MM/YYYY"
                  format={isOpenBirthday ? "DDMMYYYY": "DD/MM/YYYY"}
                  onOpenChange={() => setIsOpenBirthday(!isOpenBirthday)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Giới tính</Typography.Text>}
                name="gioiTinhThanNhan"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Select 
                  className='data-select-field'
                  placeholder='Chọn'
                  options={gioiTinhOptions.filter(it => it.value != null)}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={
                  <Typography.Text ellipsis>Số điện thoại</Typography.Text>
                }
                name="dienThoaiThanNhan"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                rules={[{validator: validatePhoneNumberLength}]}
              >
                <Input 
                  className='data-input-field'
                  placeholder='Chọn'
                  onBlur={onPhoneBlur}
                  onFocus={onPhoneFocus}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item 
              label={<Typography.Text ellipsis>Tỉnh</Typography.Text>}
              name='tinhThanNhan'
              labelAlign='left'
              labelCol={{span: 8}}
              wrapperCol={{span: 16}}
            >
              <Select 
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                className='data-select-field'
                placeholder='Chọn'
                allowClear={true}
                options={provinces ? toOptions(provinces): []}
                onChange={onProvinceChange}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item 
              label={<Typography.Text ellipsis>Huyện</Typography.Text>}
              name='huyenThanNhan'
              labelAlign='left'
              labelCol={{span: 8}}
              wrapperCol={{span: 16}}
            >
              <Select 
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                className='data-select-field'
                placeholder='Chọn'
                allowClear
                options={districts ? toOptions(districts): []}
                onChange={onDistrictChange}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item 
              label={<Typography.Text ellipsis>Xã</Typography.Text>}
              name='xaThanNhan'
              labelAlign='left'
              labelCol={{span: 8}}
              wrapperCol={{span: 16}}
            >
              <Select 
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                className='data-select-field'
                placeholder='Chọn'
                allowClear
                options={communes ? toOptions(communes): []}
              />
            </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item 
                label={<Typography.Text ellipsis>Địa chỉ</Typography.Text>}
                name='diaChiThanNhan'
                labelAlign='left'
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Select
                  className="data-select-field"
                  placeholder="Chọn"
                  allowClear={true}
                  options={provinces ? toOptions(provinces) : []}
                  onChange={onProvinceChange}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item 
              label={<Typography.Text ellipsis>Quan hệ với BN</Typography.Text>}
              name='quanHeThanNhan'
              labelAlign='left'
              labelCol={{span: 8}}
              wrapperCol={{span: 16}}
            >
              <AutoComplete
                showSearch
                allowClear
                notFoundContent={null}
                defaultActiveFirstOption={false}
                filterOption={(inputValue, option) =>
                  option!.label
                    .toString()
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                options={relation ? toRelation(relation): []}
              ></AutoComplete>
            </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </Row>
  );
};

export default RelativeInfo;
